import React from 'react'
import axios from "axios";
import en from '../../../locales/en/translation.json';
import fr from '../../../locales/fr/translation.json';

export default class Actualites extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            lang: 'en',
            trad: en,
            actus: null,
        }
    }

    componentDidMount() {
        document.title = "Actualites | WonderPlace";
        document.querySelector('body').classList.add('actualite_page');
        let url = import.meta.env.VITE_BACKEND_URL + '/actualite/get';
        axios.get(url)
            .then((response) => {
                this.setState({
                    actus: response.data
                })
            }).catch((error) => {
                console.log(error);
            });
    }

    render(){
        return(
            <>
                <div className="titre">
                    <h1>Actualites</h1>
                    <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit. Sed non risus. Suspendisse lectus
                        tortor, dignissim sit amet, adipiscing nec, ultricies sed, dolor.<br/>
                        Cras elementum ultrices diam. Maecenas ligula massa, varius a, semper congue, euismod non, mi.
                    </p>
                </div>
                <div className="actualites">
                    {
                        this.state.actus && this.state.actus.map((actu, index) => (
                            <a href={`/actualite/${actu.slug}`} target="_blank" key={index}>
                                <div className="actualite" >
                                    <div className="actualite-img">
                                        <img src={import.meta.env.VITE_BACKEND_URL_IMG + "/uploads/" + actu.image}
                                             alt={actu.titre}/>
                                    </div>
                                    <div className="actualite-text">
                                        <h2>{actu.titre}</h2>
                                        <p className="description">{actu.description}</p>
                                        <p className="qui_date">Par Anne-Louise GAYMARD - 14 mars 2023</p>
                                    </div>
                                </div>
                            </a>
                        ))
                    }
                </div>
            </>
        )
    }

}
